import { render, staticRenderFns } from "./GalleryCards.vue?vue&type=template&id=77c170c0"
import script from "./GalleryCards.vue?vue&type=script&lang=js"
export * from "./GalleryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports